const state = {
  rules_manager: [],
  rules_skin: [],
  rules_disabled: [],
  template_manager: [],
  template_skin: [],
  rulesCashoutManager: [],
  rulesCashoutSkin: []
};

const getters = {
  getRulesManager: state => {
    return state.rules_manager;
  },
  getRulesDisabled: state => {
    return state.rules_disabled;
  },
  getRulesSkin: state => {
    return state.rules_skin;
  },
  getTemplateManager: state => {
    return state.template_manager;
  },
  getTemplateSkin: state => {
    return state.template_skin;
  },

  getRulesCashoutManager: state => {
    return state.rulesCashoutManager;
  },

  getRulesCashoutSkin: state => {
    return state.rulesCashoutSkin;
  }
};

const actions = {};

const mutations = {
  SET_RULES_MANAGER(state, payload) {
    state.rules_manager = payload;
  },
  SET_RULES_SKIN(state, payload) {
    state.rules_skin = payload;
  },
  SET_RULES_DISABLED(state, payload) {
    state.rules_disabled = payload;
  },
  SET_TEMPLATE_MANAGER(state, payload) {
    state.template_manager = payload;
  },
  SET_TEMPLATE_SKIN(state, payload) {
    state.template_skin = payload;
  },

  SET_RULES_CASHOUT_MANAGER(state, payload) {
    if (payload != null && payload.length >= 0) {
      state.rulesCashoutManager = payload;
    }
  },

  SET_RULES_CASHOUT_SKIN(state, payload) {
    if (payload != null && payload.length >= 0) {
      state.rulesCashoutSkin = payload;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
